import * as MapGL from 'react-map-gl/mapbox';
import { antennaCategoryMap } from './dataMaps';
import store from './store';

interface AntennaPopupProps {
  popupLocation: [number, number];
  selectedFeatures: GeoJSON.Feature<GeoJSON.Point>[];
  setSelectedFeatures: (features: GeoJSON.Feature<GeoJSON.Point>[]) => void;
  setPopupLocation: (location: [number, number] | null) => void;
}

const AntennaPopup = ({
  popupLocation,
  selectedFeatures,
  setSelectedFeatures,
  setPopupLocation,
}: AntennaPopupProps) => {
  const popupRowClick = (objectId: string) => {
    store.setSelectedObjectId(objectId);
  };

  return (
    <MapGL.Popup
      key={popupLocation.toString()}
      latitude={popupLocation[1]}
      longitude={popupLocation[0]}
      maxWidth="auto"
      onClose={() => {
        setSelectedFeatures([]);
        setPopupLocation(null);
      }}
    >
      <div className="w-[450px] p-2">
        <div className="max-h-52 overflow-y-auto">
          <table>
            <thead>
              <tr>
                <th className="w-[250px] text-xs font-medium">Owner</th>
                <th className="text-xs font-medium">Category</th>
              </tr>
            </thead>
            <tbody>
              {selectedFeatures.map((feature, index) => (
                <tr
                  // biome-ignore lint/suspicious/noArrayIndexKey: legacy
                  key={index}
                  className="cursor-pointer"
                  onClick={() => {
                    popupRowClick(feature.properties?.OBJECTID.toString());
                  }}
                >
                  <td className="w-[300px] text-xs">{feature.properties?.owner}</td>
                  <td className="text-xs">
                    {antennaCategoryMap[feature.properties?.category] || feature.properties?.category}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MapGL.Popup>
  );
};

export default AntennaPopup;
